import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=0673c4a6"
import script from "./Tab.js?vue&type=script&lang=js&external"
export * from "./Tab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports